export function parseQuery(query:any) {
  const parts = query.replace('?', '').split('&');
  const params = parts.reduce((acc:any, str:any) => {
    const [key, value] = str.split('=');
    acc[key] = value;
    return acc;
  }, {});
  return params;
}

export function removeQueryParams(...params: any[]) {
  const query = new URLSearchParams(window.location.search.replace('?', ''));
  params.forEach(param => query.delete(param));
  history.pushState(null, '', window.location.pathname + query);
}

// Helper functions during development
export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isInIframe () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function extractDomainNameFromUrl(url: string) {
  var matches = url.match(/^https?\:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i);
  return matches && matches[1];  // domain will be null if no match is found
}

/**
 * Cleans a text from empty rows at the end. ["", "Hej", "", ""] => ["", "Hej"] (joined)
 * @param text
 */
export function cleanTextFromTrailingEmptyRows(text: string): string {

  if (!text) {
    return "";
  }

  let rows = text.split(/\r|\r\n|\n/)

  for (let i = rows.length - 1; i >= 0; i--)
  {
    if (rows[i] === "") {
      rows.splice(i, 1);
    } else {
      break;
    }
  }

  return rows.join("\r");
}

/**
 * We cannot necessarily use the textarea itself to determine realistic row length for e.g. a PDF since it can get resized
 * Also we cannot simply count all the rows, because if some of the text is wrapped then we may end up with one mega row of e.g. 600 chars
 *
 * This function counts the number of rows by counting the split way,
 * and then also count the chars per row to determine if it in reality consists of more than one row
 *
 * Note that this is an approximation. It is not 100 % accurate, but should be good enough
 *
 * @param text
 * @param maxRowSize
 */
export function countRowsInTextArea(text: string, maxRowSize: number): number {

    let adjustedRowCount = 0;
    text += ""; // might not be a valid string

    let rows = text.split(/\r|\r\n|\n/);

    // clean-up end rows, so that we don't have ["wadhwa", "hhdwiad", "", ""], cause such rows shouldn't count
    for (let i = rows.length - 1; i >= 0; i--)
    {
      if (rows[i] === "") {
        rows.splice(i, 1);
      } else {
        break;
      }
    }

    for (let row of rows) {

      // if there is a completely new row then it must be counted
      adjustedRowCount++;

      let rowMultiplier = Math.ceil(row.length / maxRowSize);

      // if the row is very long (i.e. in reality multiple rows due to wrapping, count additional rows
      if (rowMultiplier >= 2) {
        adjustedRowCount += rowMultiplier - 1;
      }
    }

    return adjustedRowCount;
}
